export { default } from "es6-error";
export * from "es6-error";
